import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import CacDropButtons from './enhancedFeatures/CacDropButtons';
import InfoBox, { InfoBoxSpacer } from '../common/EnhancedGridFeature/InfoBox';
import downArrow from '../../images/corrcluster/downArrow.svg';
import {
  CAC_CREATE_NEW_PROJECT,
  CAC_DUPLICATE_PROJECT,
  CAC_EDIT_PROJECT_NAME,
  CAC_PROJECT_TITLE_LENGTH,
} from './CacConstants';
import GenericInlineEdit from '../common/GenericInlineEdit';
import { useProjectContext } from './context/ProjectContext';

const CacMapTitleAndDropdown = props => {
  const { projectTitle } = props;
  const [dropPanels, setDropPanels] = useState([]);
  const inputElement = useRef(null);
  const infoBoxRef = useRef(null);

  const { handleEditTabName } = useProjectContext();

  const buildInfoBox = () => {
    if (dropPanels.length === 0) {
      const ibp = [];
      ibp.push(<CacDropButtons
        label={CAC_DUPLICATE_PROJECT}
        infoBoxRef={infoBoxRef}
      />);
      ibp.push(<InfoBoxSpacer Height="0.1em" boxClassName='toolPalette-spacer-row' />);
      ibp.push(<CacDropButtons label={CAC_CREATE_NEW_PROJECT} />);
      ibp.push(<InfoBoxSpacer Height="0.1em" boxClassName='toolPalette-spacer-row' />);
      ibp.push(<CacDropButtons
        label={CAC_EDIT_PROJECT_NAME}
        inputElement={inputElement}
        infoBoxRef={infoBoxRef}
      />);
      setDropPanels(ibp);
    }
    return (dropPanels);
  };

  return (
    <div
      className="view-right-content-title-container"
      data-test="mapTitleDropdownComponent"
    >
      <div className="view-right-content-title">
        <GenericInlineEdit
          data-test="inLineEditComponent"
          ref={inputElement}
          validate={text => text.length > 0 && text.length < 61}
          maxLength={CAC_PROJECT_TITLE_LENGTH}
          crosstabViewFlag
          activeClassName="editing"
          text={projectTitle}
          paramName="newProjectName"
          style={{
            backgroundColor: '#94A2B7',
            color: '#FFFFFF',
            border: 'none',
            height: '25px',
            padding: '4px',
            margin: '2px',
          }}
          change={updatedObjectProps => handleEditTabName(updatedObjectProps)}
        />
        <span className="view-right-content-drop">
          <InfoBox
            ref={infoBoxRef}
            Panels={buildInfoBox()}
            updatePanels={buildInfoBox}
            Positions={['bottom']}
            Align="start"
            InfoBoxButtonInner={
              <img className="ibox-downArrow" src={downArrow} alt="v" />
            }
            containerClassName='ib-popover-dd-container'
          />
        </span>
      </div>
    </div>
  );
};

CacMapTitleAndDropdown.propTypes = {
  projectTitle: PropTypes.string,
};

export default CacMapTitleAndDropdown;
